import React from 'react';
import GoogleMapsComponent from "../../Ui/GoogleMapsComponent";
import {generateRandomString, get} from "../../../utils/helpers";


export default function GoogleMapsInput(props){

    const {form,field} = props;

    const fieldValue = field.value;

    const location = {
        lat: fieldValue ? fieldValue.lat : undefined,
        lng: fieldValue ? fieldValue.lng : undefined
    };

    function onPositionChoosed({lat,lng}){

        //On verifie dabord si cette position correspond a une position qui existait déja

        form.setFieldValue(field.name,[
            ...fieldValue,
            {
                key: generateRandomString(6),
                lat, lng
            }
        ])

    }

    function onMarkerClicked({key, lat,lng}){

        //On verifie dabord si cette position correspond a une position qui existait déja

        form.setFieldValue(field.name,fieldValue.filter(
            item => item.key !== key
        ))

    }



    return (
        <span>

        <GoogleMapsComponent
            onPositionChoosed={onPositionChoosed}
            onMarkerClicked={onMarkerClicked}
            markers={fieldValue}
        />
            {

                get(form.errors,field.name,undefined) && (

                    <div className={'small text-danger font-weight-bold'}>
                        {get(form.errors,field.name,undefined) }
                    </div>

                )

            }
        </span>
    )
}